<template>

	<div class="news-promo container-fluid theme-light-gray">
		
		<TitleHeader :subtitle="subtitle" :title="title"></TitleHeader>

		<div class="container news-promo__grid-container">

			<div class="news-promo__grid news-promo__grid--full" :key="item.id" v-for="item in fullWidthNewsItems">
				<NewsItem :newsItem="item" :key="item.id" class="news-promo__item"></NewsItem>
			</div>

			<div class="news-promo__grid news-promo__grid--half">
				<NewsItem :newsItem="item" :key="item.id" v-for="item in halfWidthNewsItems" class="news-promo__item"></NewsItem>
			</div>

			<div class="news-promo__grid news-promo__grid--mini">
				<NewsItem :newsItem="item" :key="item.id" v-for="item in miniNewsItems" class="news-promo__item"></NewsItem>
			</div>
		</div>
	
		<PrimaryButton class="center" v-if="cta" :linkText="cta.linkText" :linkURL="cta.linkURL"></PrimaryButton>
		
	</div>
	
</template>

<script>

	import NewsItem from './NewsItem.vue';
	import TitleHeader from '../Global/TitleHeader.vue';
	import PrimaryButton from '../Global/PrimaryButton.vue';
	
	export default {
		name: 'News',
		
		props: ['subtitle', 'title', 'fullWidthNewsItems', 'halfWidthNewsItems', 'miniNewsItems', 'cta'],
		
		components: {
			TitleHeader,
			PrimaryButton,
			NewsItem
		}
	}
	
</script>